import UserSelectionsContainer from '@modules/sportOffer/UserSelectionsContainer.vue';

import { shellLocalConfig } from '@src/config/shell/localConfig';
import { omit } from 'lodash';
import { defaultLayout } from '@app/router/utils';
import { currentSite } from '@app/utils/domainHelpers';
import { Site } from '@superbet-group/web.types';
import { loadAsyncWithLoadingState } from '@src/app/utils/loadAsyncComponent';
import AccountMobileHeader from '@modules/userProfile/AccountMobileHeader.vue';

const defaultLayoutWithTickets = {
    ...defaultLayout,
    mobileHeader: AccountMobileHeader,
    rightSidebar: UserSelectionsContainer,
    mobileBottomContent: UserSelectionsContainer,
};

const defaultLayoutWithoutTickets = omit({
    ...defaultLayoutWithTickets,
    rightSidebar: undefined,
}, ['tickets']);

// TODO: Figure out an elegant way to remove domain specific logic from here
const shouldContainTickets = shellLocalConfig.hasTicketsOutsideSportsProduct
    || currentSite === Site.NapoleonSports;

const finalDefaultLayout = shouldContainTickets
    ? defaultLayoutWithTickets
    : defaultLayoutWithoutTickets;

export const profilePage = {
    ...finalDefaultLayout,
    content: loadAsyncWithLoadingState<unknown>(() => import('./ProfilePage.vue')),
    leftSidebar: () => import('@src/app/modules/userProfile/SdsProfileSidebar.vue'),
};
